<template>
  <img
    class="background"
    v-if="resourceStore.backgroundImage"
    :src="resourceStore.backgroundImage"
  />
  <img
    class="logo-new"
    v-if="resourceStore.logoNewImage"
    :src="resourceStore.logoNewImage"
    @click="goHome"
    style="cursor: pointer"
  />
</template>

<script setup>
import { useResourceStore } from "@/store/resourceStore";
import { useRouter } from "vue-router";

const resourceStore = useResourceStore();
const router = useRouter();

const goHome = () => {
  router.push("/");
};
</script>

<style scoped lang="scss">
// 移动端样式
@media screen and (max-width: 768px) {
  .background {
    position: fixed;
    object-fit: cover;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    pointer-events: none;
  }

  .logo-new {
    position: absolute;
    top: 2.81vh;
    width: 21.11vw;
    height: 16.67vw;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    object-fit: contain;
  }
}

// PC端样式
@media screen and (min-width: 769px) {
  .background {
    position: fixed;
    object-fit: cover;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    pointer-events: none;
  }

  .logo-new {
    position: absolute;
    top: 4.63vh;
    width: 21.11vh;
    height: 14.81vh;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    object-fit: contain;
  }
}
</style>
